module.exports = __webpack_public_path__ + "img/Shop-in-shop application form_2.017b9a0d.jpg";